export default "__VITE_ASSET__BEDaRCmG__"